import React, { useEffect, useState } from 'react'
import useStyles from './header.styles'
import { setCookie, getCookie } from '../../../utils/cookies'

const AlertContent = ({ icon, text, setState }) => {
  const classes = useStyles()
  const [viewBar, setViewBar] = useState(false)

  const hideBar = () => {
    setCookie('hidebar', 'on', 1)
    setViewBar(false)
    setState(false)
  }

  useEffect(() => {
    if (getCookie('hidebar') !== 'on') {
      setViewBar(true)
      setState(true)
    }
  }, [])

  if (!viewBar) {
    return null
  }

  return (
    <div id="headerAlertBar" style={{ backgroundColor: '#e6f1f9', padding: '10px' }}>
      <div
        style={{
          width: '100%',
          maxWidth: '1220px',
          margin: '0 auto',
          justifyContent: 'space-between',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div style={{ paddingRight: '10px', display: 'flex', alignItems: 'center' }}>
          <img
            style={{ mixBlendMode: 'multiply', marginRight: '8px' }}
            src={`/themes/thrifty/assets/images/${icon}.png`}
            alt=""
            width="20px"
            height="20px"
          />
          <span dangerouslySetInnerHTML={{ __html: text }} className={classes.alertBarText} />
        </div>
        <button
          onClick={hideBar}
          type="button"
          style={{ border: 'none', backgroundColor: 'transparent', cursor: 'pointer' }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.3525 1.38372C17.7667 0.797933 16.8169 0.797933 16.2311 1.38372L9.86719 7.74768L3.50323 1.38372C2.91744 0.797932 1.96769 0.797932 1.38191 1.38372C0.796119 1.96951 0.796119 2.91925 1.38191 3.50504L7.74587 9.869L1.3819 16.233C0.796119 16.8187 0.796118 17.7685 1.3819 18.3543C1.96769 18.9401 2.91744 18.9401 3.50323 18.3543L9.86719 11.9903L16.2311 18.3543C16.8169 18.9401 17.7667 18.9401 18.3525 18.3543C18.9383 17.7685 18.9383 16.8187 18.3525 16.233L11.9885 9.869L18.3525 3.50504C18.9383 2.91925 18.9383 1.96951 18.3525 1.38372Z"
              fill="#666"
            />
          </svg>
        </button>
      </div>
    </div>
  )
}

const AlertBar = ({ alertBars, WebSettings, setState }) => {
  if (Number(alertBars.BAR_ALERT) === 0) {
    return <AlertContent setState={setState} icon="alert_icon" text={WebSettings.BAR_ALERT} />
  }

  if (Number(alertBars.BAR_HOT_DEAL) === 0) {
    return <AlertContent setState={setState} icon="hot_deal_icon" text={WebSettings.BAR_HOT_DEAL} />
  }

  if (Number(alertBars.BAR_INFORMATION) === 0) {
    return <AlertContent setState={setState} icon="Info_Icon" text={WebSettings.BAR_INFORMATION} />
  }

  return null
}

export default AlertBar